<template>
  <div>
    <span
      @click="dialog = true"
      style="cursor: pointer"
      title="Editar"
    >
      {{ Helpers.formatarValorComCasas(item.tempo_medio_ressuprimento, 2) }}
    </span>

    <SysDialog
      v-model="dialog"
      :titulo="TITULO_DIALOG"
      :largura="LARGURA_DIALOG"
      @click:primary="editar()"
    >
      <p v-if="produtos_selecionados.length > 0">
        <v-icon color="orange">mdi-alert</v-icon>
        A alteração será aplicada aos itens previamente marcados.
      </p>

      <TextFieldFormatadorDeValor
        v-model="editar_item.tempo_medio_ressuprimento"
        label="Tempo Ressuprimento"
        outlined
        :error-messages="TEMPO_RESSUPRIMENTO_ERRORS"
        :messages="TEMPO_RESSUPRIMENTO_ZERO"
        @input="$v.editar_item.tempo_medio_ressuprimento.$touch()"
        @blur="$v.editar_item.tempo_medio_ressuprimento.$touch()"
      />
    </SysDialog>
  </div>
</template>

<script>
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import { required, decimal } from "vuelidate/lib/validators";
import { editarRessuprimento } from "../Api"

export default {
  components: {
    SysDialog,
    TextFieldFormatadorDeValor
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    produtos_selecionados: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    editar_item: {}
  }),
  validations: {
    editar_item: {
      tempo_medio_ressuprimento: { required, decimal }
    }
  },
  watch: {
    dialog(valor) {
      if (valor) this.editar_item = Object.assign({}, this.item);
    }
  },
  computed: {
    TITULO_DIALOG() {
      return 'Editar tempo ressuprimento';
    },
    LARGURA_DIALOG() {
      return 450;
    },
    TEMPO_RESSUPRIMENTO_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.tempo_medio_ressuprimento.$dirty) return errors;
      !this.$v.editar_item.tempo_medio_ressuprimento.decimal && errors.push("Campo Obrigatório.");
      return errors;
    },
    TEMPO_RESSUPRIMENTO_ZERO() {
      return "Ao zerar, o ressuprimento será convertido para automatico.";
    },
  },
  methods: {
    editar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let parametros = {
          grupo: this.item.id_grupo,
          filial: this.item.filial,
          tempo_ressuprimento: this.editar_item.tempo_medio_ressuprimento,
          produtos: []
        };

        parametros.produtos = this.produtos_selecionados.length == 0 ? [this.item] : this.produtos_selecionados;

        this.$store.dispatch(
          'loading/addRequisicao',
          editarRessuprimento(parametros)
            .then(() => {
              this.$emit('atualizar-tela-inicial');
              this.dialog = false;
            })
            .catch(() => this.Helpers.logout())
        );
      }
    }
  }
}
</script>

<style>

</style>
